import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import QuestionsAnalytics from '../../components/moment/QuestionsAnalytics';

import { fetchFilterInteractionStatistics, fetchUsersInteraction } from '../../modules';
import API from '../../../../../utils/api';

const mapDispatchToProps = dispatch => ({
  fetchFilterInteractionStatistics(interactionId) {
    dispatch(fetchFilterInteractionStatistics(interactionId));
  },
  fetchUsersInteraction(listUsersWithData, from, to, userAnonymous) {
    dispatch(fetchUsersInteraction(listUsersWithData, from, to, userAnonymous));
  },
});

const mapStateToProps = state => {
  return {};
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('showModal', 'setShowModal', false),
  withState('users', 'setUsers', []),
  withState('interactionStatistics', 'setInteractionStatistics', null),
  withHandlers({
    getUsers: props => async users => {
      const { data } = await API.getUserInteractions({ users });

      if (data && data.docs && data.docs.length > 0) {
        props.setUsers(data.docs);
      }
    },
  }),
  withHandlers({
    init: props => async interactionId => {
      const { data } = await API.getInteractionStatistics({
        interaction: interactionId,
      });

      if (data) {
        props.setInteractionStatistics(data);

        if (data.users && data.users.length > 0) {
          props.getUsers(data.users);
        }
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.interaction && this.props.interaction._id) {
        this.props.init(this.props.interaction._id);
      }
    },
  })
);

export default enhance(QuestionsAnalytics);
